(() => {
  'use strict';

  const CONTACT_PATH = '/pages/contact-met-paulissen-witgoed';
  const CONTACT_CONTEXT_KEY = 'pw-product-contact-context';
  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const sendAnalyticsEvent = (eventName, parameters = {}) => {
    const payload = Object.fromEntries(Object.entries(parameters).filter(([, value]) => value !== '' && value !== null && value !== undefined));
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  };

  const initializeProductContactContext = (section) => {
    if (section.dataset.productContactReady === 'true') return;
    section.dataset.productContactReady = 'true';
    let variants = [];
    try {
      variants = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '[]');
    } catch (error) {
      console.warn('Productcontext kon de variantgegevens niet lezen.', error);
    }
    const variantSelect = section.querySelector('[data-variant-select]');
    const hiddenVariant = section.querySelector('.pw-product__form [name="id"]');
    const vendorLink = section.querySelector('.pw-product-context a[href*="/collections/vendors"]');
    const categoryLinks = [...section.querySelectorAll('.pw-product-context a')];
    const categoryLink = categoryLinks.find((link) => link !== vendorLink);
    const getCurrentVariant = () => {
      const variantId = variantSelect?.value || hiddenVariant?.value || '';
      return variants.find((variant) => String(variant.id) === String(variantId)) || variants[0] || {};
    };
    const getProductContext = () => {
      const variant = getCurrentVariant();
      const sku = cleanText(variant.sku || section.querySelector('[data-variant-sku]')?.textContent).replace(/^—$/, '');
      const brand = cleanText(vendorLink?.textContent).replace(/^Meer van\s+/i, '');
      const category = cleanText(categoryLink?.textContent).replace(/^Alle\s+/i, '').replace(/^Bekijk categorie:\s*/i, '');
      const productName = cleanText(section.dataset.productTitle || section.querySelector('.pw-product__title')?.textContent);
      const productUrl = new URL(window.location.href);
      productUrl.search = '';
      if (variant.id) productUrl.searchParams.set('variant', variant.id);
      productUrl.hash = '';
      return {
        contact_topic: 'product', product_name: productName, brand, category, sku,
        variant: cleanText(variant.title).replace(/^Default Title$/i, ''),
        variant_id: variant.id ? String(variant.id) : '',
        item_id: sku || (variant.id ? String(variant.id) : productUrl.pathname.split('/').filter(Boolean).pop() || ''),
        product_url: productUrl.toString(), contact_source: 'product_page'
      };
    };
    const isContactLink = (anchor) => {
      if (!(anchor instanceof HTMLAnchorElement)) return false;
      try {
        const url = new URL(anchor.href, window.location.origin);
        return url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === CONTACT_PATH;
      } catch (_error) {
        return false;
      }
    };
    const updateContactLinks = () => {
      const context = getProductContext();
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      document.querySelectorAll('a[href]').forEach((anchor) => {
        if (!isContactLink(anchor)) return;
        const contactUrl = new URL(anchor.href, window.location.origin);
        Object.entries(context).forEach(([key, value]) => { if (value) contactUrl.searchParams.set(key, value); });
        if (previewThemeId) contactUrl.searchParams.set('preview_theme_id', previewThemeId);
        anchor.href = contactUrl.toString();
        if (anchor.dataset.productContactTracked === 'true') return;
        anchor.dataset.productContactTracked = 'true';
        anchor.addEventListener('click', () => {
          const currentContext = getProductContext();
          try { window.sessionStorage.setItem(CONTACT_CONTEXT_KEY, JSON.stringify(currentContext)); } catch (_error) {}
          sendAnalyticsEvent('product_contact_click', {
            item_id: currentContext.item_id, item_name: currentContext.product_name,
            item_brand: currentContext.brand, item_category: currentContext.category,
            item_variant: currentContext.variant, contact_source: currentContext.contact_source,
            link_text: cleanText(anchor.textContent)
          });
        });
      });
    };
    variantSelect?.addEventListener('change', updateContactLinks);
    updateContactLinks();
  };

  const initializePurchaseFlow = (section) => {
    if (!(section instanceof Element) || section.dataset.purchaseFlowReady === 'true') return;
    section.dataset.purchaseFlowReady = 'true';
    initializeProductContactContext(section);

    const hero = section.querySelector('.pw-product-hero');
    const form = section.querySelector('.pw-product__form');
    const button = section.querySelector('[data-add-to-cart]');
    const feedback = section.querySelector('[data-cart-feedback]');
    const serviceContainer = section.querySelector('[data-product-services]');
    const servicePanel = serviceContainer?.closest('.pw-product-services-panel');
    const advisor = section.querySelector('.pw-product-advisor');

    if (advisor) {
      advisor.classList.add('pw-product-advisor--secondary');
      (servicePanel || hero)?.insertAdjacentElement('afterend', advisor);
    }
    if (!form || !button || !serviceContainer) return;

    const serviceHeading = serviceContainer.querySelector('.pw-product-services__heading');
    const serviceTitle = serviceHeading?.querySelector('h2');
    const serviceCopy = serviceHeading?.querySelector('p');
    const summary = serviceContainer.querySelector('.pw-service-summary');
    const quantityField = form.querySelector('.pw-field--quantity');
    const quantityInput = quantityField?.querySelector('[name="quantity"]');
    const serviceContent = [...serviceContainer.children].filter((child) => child !== serviceHeading && child !== form);

    if (serviceTitle) serviceTitle.textContent = 'Kies eventueel uw extra diensten';
    if (serviceCopy) serviceCopy.textContent = 'Deze keuzes zijn niet verplicht. U kunt het apparaat ook zonder extra dienst bestellen.';
    if (!form.id) form.id = `PWProductForm-${Math.random().toString(36).slice(2, 10)}`;

    button.removeAttribute('form');
    quantityInput?.removeAttribute('form');
    if (serviceHeading) serviceHeading.insertAdjacentElement('afterend', form);
    else serviceContainer.prepend(form);

    form.classList.toggle('pw-product__form--metadata-only', !form.querySelector('.pw-field--variant'));
    if (quantityField) quantityField.remove();
    button.remove();
    if (feedback) feedback.remove();
    serviceContent.forEach((child) => form.append(child));

    if (quantityField) {
      if (summary && form.contains(summary)) summary.insertAdjacentElement('beforebegin', quantityField);
      else form.append(quantityField);
    }

    const purchase = document.createElement('div');
    purchase.className = 'pw-service-purchase';
    const purchaseCopy = document.createElement('p');
    purchaseCopy.innerHTML = '<strong>Klaar met kiezen?</strong><span>Controleer het totaal en voeg het apparaat daarna toe aan uw winkelwagen.</span>';
    purchase.append(purchaseCopy, button);
    if (feedback) purchase.append(feedback);
    if (summary && form.contains(summary)) summary.insertAdjacentElement('afterend', purchase);
    else form.append(purchase);
  };

  const initializeAll = () => document.querySelectorAll('[data-product-section]').forEach(initializePurchaseFlow);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
})();
